import React from 'react';

const Services = () => {
  const services = [
    {
      icon: '🏠',
      image: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      title: 'Personal Care',
      description: 'Assistance with daily activities including bathing, dressing, medication management, and mobility support.'
    },
    {
      icon: '👩‍⚕️',
      image: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      title: '24/7 Professional Care',
      description: 'Round-the-clock care from qualified healthcare professionals ensuring safety and well-being at all times.'
    },
    {
      icon: '🍽️',
      image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      title: 'Nutritious Meals',
      description: 'Freshly prepared, nutritious meals tailored to dietary needs and preferences, served in a comfortable dining environment.'
    },
    {
      icon: '🎨',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      title: 'Recreation & Activities',
      description: 'Engaging social activities, recreation programs, and therapeutic activities to promote mental and physical wellness.'
    },
    {
      icon: '🏡',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      title: 'Comfortable Accommodation',
      description: 'Private and semi-private rooms with comfortable furnishings and a warm, home-like atmosphere.'
    },
    {
      icon: '👨‍👩‍👧‍👦',
      image: 'https://images.unsplash.com/photo-1609220136736-443140cffec6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      title: 'Family Support',
      description: 'Regular communication with families and support services to ensure peace of mind for loved ones.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>Comprehensive care tailored to individual needs</p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-image">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="service-photo"
                />
                <div className="service-icon-overlay">
                  <span>{service.icon}</span>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;